var map = {
	"./auth/access.vue": [
		"98f0",
		"chunk-2d0e68df"
	],
	"./customer.vue": [
		"656d",
		"chunk-2d0cfae3"
	],
	"./errors/404.vue": [
		"4b62",
		"chunk-6ec97b40"
	],
	"./feedback.vue": [
		"c6bd",
		"chunk-7113c181"
	],
	"./fill_location.vue": [
		"9296",
		"chunk-2d0e4cec"
	],
	"./home.vue": [
		"6511",
		"chunk-6efb08e2"
	],
	"./hotel.vue": [
		"a3c2",
		"chunk-891f081e"
	],
	"./location.vue": [
		"4900",
		"chunk-2d0c203b"
	],
	"./login.vue": [
		"dd7b",
		"chunk-2d229481"
	],
	"./menu.vue": [
		"f127",
		"chunk-e109f9c4"
	],
	"./order_completed.vue": [
		"2b94",
		"chunk-53a52a40"
	],
	"./order_detail.vue": [
		"ed5e",
		"chunk-70a4642a"
	],
	"./orders.vue": [
		"ff9a",
		"chunk-2d2384fe"
	],
	"./promotion.vue": [
		"58c5",
		"chunk-447acb4c"
	],
	"./province.vue": [
		"912a",
		"chunk-350e71d6"
	],
	"./restaurant.vue": [
		"75e9",
		"chunk-64a4894e"
	],
	"./review_order.vue": [
		"739b",
		"chunk-6439a45e"
	],
	"./room.vue": [
		"5961",
		"chunk-2d0c9555"
	],
	"./select_map.vue": [
		"eeef",
		"chunk-160409a9"
	],
	"./temp/location copy.vue": [
		"7740",
		"chunk-3fa22cb0"
	],
	"./test.vue": [
		"2762",
		"chunk-2d0b30b7"
	],
	"./under_maintenance.vue": [
		"a285",
		"chunk-576544dd"
	],
	"./view_menu.vue": [
		"1517",
		"chunk-2d0ab440"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;